import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../utils/formatPrice';

export default function Paketler() {
  const packages = [
    {
      id: 1,
      subTitle: '3 kişi 2 gece',
      title: '3 Silahşörler',
      price: '₺14500',
      ccPrice: '₺15056',
      description: '',
      features: [
        'Ultra her şey dahil',
        '2 gece konaklama',
        'Bayrak Töreni katılımı',
        'Gala yemeği katılımı',
      ],
      image: '/images/silahşör.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 2,
      subTitle: '2 kişi 2 gece',
      title: 'Hansel ve Gretel',
      price: '₺15300',
      ccPrice: '₺15886',
      description: '',
      features: [
        'Ultra her şey dahil',
        '2 gece konaklama',
        'Bayrak Töreni katılımı',
        'Gala yemeği katılımı',
      ],
      image: '/images/hansel.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 3,
      subTitle: '1 kişi 2 gece',
      title: "Alice'in Anahtarı",
      price: '₺18500',
      ccPrice: '₺19209',
      description: '',
      features: [
        'Ultra her şey dahil',
        '2 gece konaklama',
        'Bayrak Töreni katılımı',
        'Gala yemeği katılımı',
      ],
      image: '/images/alice.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 4,
      subTitle: '3 kişi 1 gece cuma',
      title: 'Aslan, Cadı ve Dolap',
      price: '₺9000',
      ccPrice: '₺9345',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Bayrak Töreni katılımı',
      ],
      image: '/images/cadı_aslan_dolap.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 5,
      subTitle: '3 kişi 1 gece cumartesi',
      title: 'Camelot Konseyi',
      price: '₺11300',
      ccPrice: '₺11733',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Gala yemeği katılımı',
      ],
      image: '/images/camelot konseyi.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 6,
      subTitle: '2 kişi 1 gece cuma',
      title: 'Küçük Prens ve Tilki',
      price: '₺9600',
      ccPrice: '₺9968',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Bayrak Töreni katılımı',
      ],
      image: '/images/küçük prens.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 7,
      subTitle: '2 kişi 1 gece cumartesi',
      title: 'Ay Işığı Balosu',
      price: '₺11800',
      ccPrice: '₺12252',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Gala yemeği katılımı',
      ],
      image: '/images/ay ışığo.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 8,
      subTitle: '1 kişi 1 gece cuma',
      title: 'Rapunzel’in Kulesi',
      price: '₺11500',
      ccPrice: '₺11941',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Bayrak Töreni katılımı',
      ],
      image: '/images/rapunzel.webp',
      cta: 'Kayıtlar Kapandı',
    },
    {
      id: 9,
      subTitle: '1 kişi 1 gece cumartesi',
      title: 'Büyülü Balkabağı',
      price: '₺13700',
      ccPrice: '₺14225',
      description: '',
      features: [
        'Ultra her şey dahil',
        '1 gece konaklama',
        'Gala yemeği katılımı',
      ],
      image: '/images/balkabağı.webp',
      cta: 'Kayıtlar Kapandı',
    },
  ];

  return (
    <section className="py-5 paketler-page" style={{ backgroundColor: 'transparent' }}>
      <div className="container">
        <h1 className="text-center mb-5" style={{marginTop: '50px'}}>Konaklama Paketleri</h1>
        <div className="row">
          {packages.map((pkg) => (
            <div className="col-lg-4 mb-4" key={pkg.id}>
              <div
                className={`card h-100 ${pkg.featured ? 'shadow-lg' : ''}`}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.08)', /* Transparent glass effect */
                  borderColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '24px',
                  backdropFilter: 'blur(12px)', /* Strong glassmorphism effect */
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  overflow: 'hidden', /* Ensure image doesn't break border radius */
                  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)'
                }}
              >
                <div className="pkg-header-container">
                  <h5 className="card-title ana-paketler-card-title" style={{ color: '#fff' }}>{pkg.title}</h5>
                </div>
                <div className="pkg-img-wrapper">
                  <img src={pkg.image} alt={pkg.title} className="card-img-top" style={{ objectFit: 'cover', height: '100%' }} />
                </div>
                <div className="card-body d-flex flex-column text-center" style={{ color: '#fff' }}>
                  <p className="ana-paketler-subtitle mb-2" style={{ color: '#fff' }}>{pkg.subTitle}</p>
                  {pkg.description && (
                    <p className="small" style={{ color: '#fff' }}>{pkg.description}</p>
                  )}
                  <div className="mb-4 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '75px' }}>
                    <div className="h3 mb-0" style={{ color: '#fff', fontWeight: 'bold' }}>{formatPrice(pkg.price)}</div>
                    <small style={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '0.8rem', marginTop: '4px' }}>(Kişi Başı Ücretidir)</small>
                  </div>
                  <ul className="list-unstyled mb-4 flex-grow-1">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className="mb-2" style={{ color: '#fff' }}>
                        <i className="bi bi-check-circle-fill text-white me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/kayit-ol"
                    className="btn w-100"
                    style={{
                      backgroundColor: pkg.featured ? '#742640' : 'transparent',
                      color: '#fff',
                      borderColor: '#fff',
                    }}
                  >
                    {pkg.cta}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
